import { ActivityType } from '../../../_models/activityType';
import { ActivityService } from './../../../_services/activity.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-activity-type-new',
  templateUrl: './activity-type-new.component.html',
  styleUrls: ['./activity-type-new.component.css']
})
export class ActivityTypeNewComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  errorMessage = '';
  errorEncountered=false
  isLoggedIn = false;

  constructor(
      private formBuilder: FormBuilder,
      private router: Router,
      private activityService:ActivityService

  ) {

  }

  ngOnInit() {
      this.form = this.formBuilder.group({
        name: ['', Validators.compose([Validators.required,Validators.minLength(3)])]
      });

  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit(): void {
      this.submitted = true;

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.errorEncountered=false
        let activityType = new ActivityType()

        activityType.name = this.form.value.name

        this.activityService.newActivity(activityType).subscribe(
          data=>{
            this.loading=false
            this.router.navigate(['user/activity/type/list'])
          },
          err=>{
            this.loading=false
            this.errorMessage = err.error.message;
            this.errorEncountered=true
          }
        )
  }



}


